var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.infopointOptions,"disabled":_vm.disabled,"reduce":label => label.code,"label":"label"},model:{value:(_vm.ipId),callback:function ($$v) {_vm.ipId=$$v},expression:"ipId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }